import { createContext, useContext, useState, useEffect, useRef } from 'react';
import Modal from 'components/layout/modal';
import useMobile from 'hooks/use_mobile';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modals, setModals] = useState([]);
  const modalIdCounter = useRef(0);
  const isMobile = useMobile();

  const addModal = (modalContent, options = {}) => {
    const id = ++modalIdCounter.current;
    setModals((prevModals) => [...prevModals, { id, content: modalContent, options }]);
  };

  const removeModal = () => {
    setModals((prevModals) => prevModals.slice(0, -1));
  };

  const hasModal = modals.length > 0;

  const hideChildren = isMobile && hasModal;

  useEffect(() => {
    if (hasModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [hasModal]);
  return (
    <ModalContext.Provider value={{ addModal, removeModal }}>
      {modals.map((modal) => (
        <Modal key={modal.id} handleClose={removeModal} {...modal.options}>
          {modal.content}
        </Modal>
      ))}
      {!hideChildren && children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
